import { z } from 'zod';

import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants/pagination';

export const zodDeliveriesAllV2SearchSchema = z.object({
  limit: z.number().int().min(1).max(500).catch(PAGINATION_PAGE_SIZE_DEFAULT),
  page: z.number().int().min(0).default(0).catch(0),
});

export const deliveriesAllV2SearchDefaults =
  zodDeliveriesAllV2SearchSchema.parse({});
